import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { PlanTier } from "@/types/billing";

interface PlanBadgeProps {
  tier: PlanTier;
  className?: string;
}

const tierStyles: Record<PlanTier, string> = {
  free: "bg-plan-free/15 text-plan-free border-plan-free/30",
  team: "bg-plan-team/15 text-plan-team border-plan-team/30",
  growth: "bg-plan-growth/15 text-plan-growth border-plan-growth/30",
  enterprise: "bg-plan-enterprise/15 text-plan-enterprise border-plan-enterprise/30",
};

export function PlanBadge({ tier, className }: PlanBadgeProps) {
  return (
    <Badge variant="outline" className={cn("capitalize", tierStyles[tier], className)}>
      {tier}
    </Badge>
  );
}
